module.exports = __webpack_public_path__ + "static/media/[Lectures_and_Panels]2014-04-27.a59cfbe2.md";